import { render, staticRenderFns } from "./landing-menu.vue?vue&type=template&id=0fa5f18a&scoped=true&"
import script from "./landing-menu.vue?vue&type=script&lang=js&"
export * from "./landing-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa5f18a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/gp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fa5f18a')) {
      api.createRecord('0fa5f18a', component.options)
    } else {
      api.reload('0fa5f18a', component.options)
    }
    module.hot.accept("./landing-menu.vue?vue&type=template&id=0fa5f18a&scoped=true&", function () {
      api.rerender('0fa5f18a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "webpack/public-site-media-dunk/src/components/base/landing-menu.vue"
export default component.exports